import React, { useState } from "react";

import { useTodosContext } from "../../context/todoContext";

import Wrapper from "./NewTodo.styled";

const NewTodo = () => {
  const [newTodo, setNewTodo] = useState({ todo: "", status: false });

  const { createNewTodo } = useTodosContext();

  const submitHandler = (e) => {
    e.preventDefault();
    if (newTodo.todo.trim() === "") {
      return;
    }

    createNewTodo(newTodo);
    setNewTodo({ todo: "", status: false });
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewTodo((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const changeStatus = (e) => {
    const { name, checked } = e.target;
    setNewTodo((prev) => {
      return { ...prev, [name]: checked };
    });
  };

  return (
    <Wrapper onSubmit={submitHandler}>
      <input
        type="checkbox"
        name="status"
        onChange={changeStatus}
        value={newTodo.status}
        checked={newTodo.status}
        className="check-input"
      />
      <input
        type="text"
        placeholder="Create a new todo..."
        name="todo"
        value={newTodo.todo}
        onChange={changeHandler}
        className="text-input"
      />
    </Wrapper>
  );
};

export default NewTodo;
